import React, { } from "react";
import { Liquid } from "@ant-design/plots";

const LiquidChart = React.forwardRef(({
    color = "#FCB24494",
    className = "",
    percent = 0.6,
    chartProps = {},
    style = {}
}, ref) => {
    const config = {
        radius: 0.9,
        color,
        outline: {
            border: 2,
            distance: 5,
        },
        ...chartProps
    };
    return (
        <div ref={ref} className={"liquid-chart "+ className} style={{ height: "100%", width: "100%", marginTop: "-5mm", ...style }}>
            <Liquid percent={percent} {...config} />
        </div>);
});

export default React.memo(LiquidChart);
